<template>
<div class="chapter">
<div class="inner_page">
<div style="text-align:center;">
<a href="https://earlybirdbooks.com/freebook/index.html?q=66e4c5824f78fae6a8fd89dd&amp;utm_campaign=front" target="_blank"><img alt="image" class="orm_ldl" src="love_1.png"/></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// love_1.vue?12515b7f